import React, { useContext, useEffect, useState } from "react";
import styles from "./styles/you.module.css";
import "./styles/you.css";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
// onboarding popups
import Cookies from "js-cookie";
import {
  handleNextClick,
  handleBackClick,
  handleCloseClick,
} from "../../../Utils/onboardingButtons";
import { UserData } from "../../../Context/DataContext";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
import legalIcon from "./styles/img/legal.svg";
import wrongIcon from "./styles/img/wrong_icon.svg";
import rightIcon from "./styles/img/right_icon.svg";
import selfRecoveryIcon from "./styles/img/self_recover_icon.svg";
import UploadAvatar from "./uploadAvatar";
import AddNotaryPopUp from "../AddNotaryPopup/AddNotaryPopup";
import EditNotaryPopup from "../EditNotaryPopup/EditNotaryPopup";
import SelfRecoveryPopUp from "../Self Recovery/SelfRecovery";
import { Select } from "antd";
import { keepAliveFrequencyTimeOptions } from "../../../Utils/timeOptions";
import { formatTime } from "../../../Utils/formatTime";
import { KeepAliveClick } from "../../../Utils/inheritance";
import { floatMessage } from "../../../Utils/floatMessage";
import { RandomId } from "../../../Utils/RandomId";
import backgroundImage from "./styles/img/you_background.png";
import PhoneInput from "react-phone-input-2";
import fr_phone_countries from "react-phone-input-2/lang/fr.json";
function You({ assets, beneficiaries, trustees, keep_alive, profile_avatar }) {
  // onboarding popups
  const userData = UserData();
  /*
    The partner's view of a customer's tree.

    The counts stay -- they are of the shared records only, since that is all
    this view holds. Everything below them goes: the keep-alive frequency, the
    check-up phone number, the next check-up date, and the legal-advisor and
    self-recovery actions are the customer's own settings, no sharing switch
    covers any of them, and none is the partner's to change.
  */
  const partnerReadOnly = Boolean(userData.partnerReadOnly);
  const hidden = partnerReadOnly ? { display: "none" } : undefined;
  const navigate = useNavigate();
  const [modal, setModal] = useState();
  const websiteCurrentLang = useContext(LanguageContext).language;

  const [content, setContent] = useState(
    websiteCurrentLang.content.User.InheritanceTree.You
  );
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  const legalData = userData?.UserData?.legal;
  const phoneNumber = userData?.UserData?.customer_phone_number;
  const [phoneInputValue, setPhoneInputValue] = useState(phoneNumber);
  const [countryCode, setCountryCode] = useState(null);
  const [countryLabel, setCountryLabel] = useState(null);
  useEffect(() => {
    setContent(websiteCurrentLang.content.User.InheritanceTree.You);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);
  const handleSavePhoneNumber = () => {
    if ([phoneInputValue !== phoneNumber]) {
      userData.edit("customer_phone_number", phoneInputValue);
      floatMessage(dublicatedcontent?.saved);
    }
  };

  return (
    <div className={styles.main}>
      <img
        src={backgroundImage}
        className={styles.background}
        alt="background"
      />
      {userData?.CustomerUser?.first_login && (
        <div class="hint_popup hint_popup_logo" id="3">
          <div class="hint_text">{content.youText1}</div>
          <div class="hint_actions">
            <button onClick={handleBackClick} class="hint_btn hint_btn--back">
              {dublicatedcontent.dublicatedText71}
            </button>
            <div className="hint_counter">4/6</div>
            <button
              onClick={handleNextClick}
              className="hint_btn hint_btn--next"
            >
              {dublicatedcontent.dublicatedText72}
            </button>
          </div>
          <button
            onClick={() => handleCloseClick(userData)}
            className="close_hint_btn"
          ></button>
        </div>
      )}
      <div className={styles.title}>{content.youText4}</div>
      <div className={styles.mainContent}>
        <div className={styles.leftSide}>
          <UploadAvatar
            modalTitle={dublicatedcontent?.edit_image}
            profile_avatar={profile_avatar}
            readOnly={partnerReadOnly}
            you={true}
            profile_id={userData.UserData.user_id}
            /*
              No `previewContainerStyles`. It used to carry
              `left: -105px; top: -15px` to drag the uploading preview back
              over the avatar, because the preview is rendered by the upload's
              itemRender and sat to the right of the trigger. The offset was
              measured against that one state, so the avatar visibly jumped
              left while the image was loading and jumped back when it landed.
              .main_container now centres itself (see uploadAvatar.module.css),
              which puts both states in the same place.
            */
          />
        </div>
        <div className={styles.right}>
          <div className={styles.userinfo}>
            <div className={styles.wallet}></div>
            <span
              onClick={() => navigate("/user/assetmanagement")}
              className={styles.userinfo_link}
            >
              {assets} {content.youText5}
            </span>
          </div>
          {/* benef */}
          <div className={styles.userinfo}>
            <div className={styles.users}></div>
            <span
              onClick={() => navigate("/user/beneficiaries")}
              className={styles.userinfo_link}
            >
              {beneficiaries} {content.youText6}
            </span>
          </div>
          {/* trusted advisors */}
          <div className={styles.userinfo}>
            <div className={styles.users}></div>
            <span
              onClick={() => navigate("/user/advisors")}
              className={styles.userinfo_link}
            >
              {trustees} {dublicatedcontent.dublicatedText64}
            </span>
          </div>
        </div>
      </div>
      <div className={styles.lower} style={hidden}>
        <p className={styles.lowerText}> {content.youText8}</p>&nbsp;
        {/* <div className={styles.lowerDaysContainer}>
          <span>{keep_alive.split(" ")[0]}</span>
        </div> */}
        <Select
          disabled={userData?.isFreezed}
          inlineIndent={0}
          suffixIcon={null}
          onChange={(e) => {
            //Please Mohammed do not change this onChange Function Please
            const new_inheritance_parameters = KeepAliveClick(
              Number(e),
              userData.UserData.inheritance_parameters
            );
            userData.setUserData({
              ...userData.UserData,
              keep_alive_timeout: Number(e),
              inheritance_parameters: new_inheritance_parameters,
              last_login: Number(Date.now()),
            });
            userData.setCustomerUser({
              ...userData.CustomerUser,
              self_recovery_status: "inactive",
            });
            userData.Update(RandomId(3));
            if (dublicatedcontent?.saved)
              floatMessage(dublicatedcontent?.saved);
          }}
          defaultValue={userData?.UserData?.keep_alive_timeout}
          dropdownStyle={{
            width: "fit-content",
            background: "white",
            padding: "0px",
          }}
          className={"select"}
          optionRender={(value, { index }) => {
            return keepAliveFrequencyTimeOptions?.map((miliseconds, i) => {
              if (index !== i) return null;
              return formatTime(
                miliseconds,
                dublicatedcontent,
                undefined,
                true
              );
            });
          }}
        >
          {keepAliveFrequencyTimeOptions?.map((miliseconds, i) => {
            return (
              <Select.Option key={i} value={miliseconds}>
                {
                  formatTime(miliseconds, dublicatedcontent, undefined).split(
                    " "
                  )[0]
                }
              </Select.Option>
            );
          })}
        </Select>
        <div className={styles.lower_innner_container}>
          <div
            style={{
              textAlign: "center",
              display: "flex",
              alignItems: "center",
            }}
          >
            <span> &nbsp;{keep_alive.split(" ")[1]}</span>
            <span> &nbsp;{content.youText10}&nbsp; </span>
          </div>
          <Select
            disabled={userData?.isFreezed}
            className={"select"}
            suffixIcon={null}
            inlineIndent={0}
            onChange={(e) => console.log(e)}
            defaultValue={"email"}
            dropdownStyle={{
              width: "fit-content",
              background: "white",
              padding: "0px",
            }}
          >
            <Select.Option value="email">Email</Select.Option>
            <Select.Option key={"2"} disabled>
              {dublicatedcontent?.applicaton_notification_coming_soon}
            </Select.Option>
            <Select.Option key={"3"} disabled>
              {dublicatedcontent?.sms_coming_soon}
            </Select.Option>
          </Select>
        </div>
      </div>
      <div
        className={`mobile_checkup_container ${phoneNumber ? "" : "red"}`}
        style={hidden}
      >
        <p>{dublicatedcontent.last_checkup_by_phone}</p>
        <div className="phone_input_continer ">
          <PhoneInput
            countryCodeEditable={false}
            localization={
              websiteCurrentLang?.label === "fr"
                ? fr_phone_countries
                : undefined
            }
            country={phoneNumber?undefined:(
              countryLabel
                ? countryLabel
                : websiteCurrentLang?.label === "fr"
                ? "fr"
                : "us")
            }
            autoFormat={true}
            placeholder={dublicatedcontent.phone_number}
            value={phoneNumber ? phoneNumber : countryCode}
            onBlur={() => {
              handleSavePhoneNumber();
            }}
            onChange={(value, country) => {
              const countryCodeLength = country.dialCode?.length;
              setCountryCode(country.dialCode);
              setCountryLabel(country.countryCode);
              const y = value.slice(countryCodeLength);

              if (y?.length === 0) {
                setPhoneInputValue(null);
              } else {
                setPhoneInputValue(value);
              }
            }}
          />
        </div>
      </div>
      <div className={styles.checkup} style={hidden}>
        <p className={styles.checkupText}>
          {content.youText11}:&nbsp;
          {dayjs(
            userData.UserData.inheritance_parameters.next_notification
          ).format("YYYY-MM-DD")}
        </p>
      </div>
      <div className={styles.bottom} style={hidden}>
        <button
          disabled={userData.isFreezed && legalData?.length <= 0}
          className={styles.bottomLeft}
          onClick={() => {
            if (legalData?.length > 0) {
              setModal(
                <EditNotaryPopup
                  disabled={userData?.isFreezed}
                  onClose={() => setModal()}
                  toEdit={legalData[0]}
                />
              );
            } else setModal(<AddNotaryPopUp onClose={() => setModal()} />);
          }}
        >
          <div
            style={{
              position: "relative",
            }}
          >
            <img src={legalIcon} alt="legal" />
            <img
              src={legalData?.length > 0 ? rightIcon : wrongIcon}
              className={styles.wrongIcon}
              alt="wrong"
            />
          </div>
          {legalData?.length > 0 ? (
            <p>{content.youText12}</p>
          ) : (
            <p>{content.youText13}</p>
          )}
        </button>
        <button
          disabled={
            userData.isFreezed &&
            !userData?.CustomerUser?.self_recovery_id_private_key
          }
          className={styles.bottomRight}
          onClick={() => {
            if (userData?.CustomerUser?.self_recovery_id_private_key) {
              setModal(
                <SelfRecoveryPopUp
                  disabled={userData.isFreezed}
                  onClose={() => setModal()}
                  toEdit={userData.CustomerUser}
                />
              );
            } else setModal(<SelfRecoveryPopUp onClose={() => setModal()} />);
          }}
        >
          <div
            style={{
              position: "relative",
            }}
          >
            <img src={selfRecoveryIcon} alt="self recovery" />
            <img
              src={
                userData?.CustomerUser?.self_recovery_id_private_key
                  ? rightIcon
                  : wrongIcon
              }
              className={styles.wrongIcon}
              alt="wrong"
            />
          </div>
          {userData?.CustomerUser?.self_recovery_key ? (
            <p>{content.youText14}</p>
          ) : (
            <p>{content.youText15}</p>
          )}
        </button>
      </div>
      {modal ? modal : null}
    </div>
  );
}

export default You;
